export type VietnamProvince = Readonly<{
  name: string;
  latitude: number;
  longitude: number;
}>;

const provinces: readonly VietnamProvince[] = [
  { name: "Hà Nội", latitude: 21.0278, longitude: 105.8342 },
  { name: "TP. Hồ Chí Minh", latitude: 10.8231, longitude: 106.6297 },
  { name: "Đà Nẵng", latitude: 16.0544, longitude: 108.2022 },
  { name: "Hải Phòng", latitude: 20.8449, longitude: 106.688 },
  { name: "Cần Thơ", latitude: 10.0371, longitude: 105.7883 },
  { name: "Bình Dương", latitude: 10.9804, longitude: 106.6519 },
  { name: "Đồng Nai", latitude: 10.9451, longitude: 106.824 },
  { name: "Khánh Hòa", latitude: 12.2388, longitude: 109.1967 },
  { name: "Thừa Thiên Huế", latitude: 16.4637, longitude: 107.5909 },
  { name: "Nghệ An", latitude: 18.6801, longitude: 105.6813 },
  { name: "Thanh Hóa", latitude: 19.8067, longitude: 105.7761 },
  { name: "Quảng Nam", latitude: 15.5751, longitude: 108.4745 },
  { name: "Quảng Ngãi", latitude: 15.12, longitude: 108.7924 },
  { name: "Bình Định", latitude: 13.782, longitude: 109.2196 },
  { name: "Phú Yên", latitude: 13.0964, longitude: 109.3203 },
  { name: "Lâm Đồng", latitude: 11.9404, longitude: 108.4583 },
  { name: "Kiên Giang", latitude: 9.9979, longitude: 105.0841 },
  { name: "Cà Mau", latitude: 9.1775, longitude: 105.15 },
  { name: "An Giang", latitude: 10.3864, longitude: 105.435 },
  { name: "Bạc Liêu", latitude: 9.2939, longitude: 105.7247 },
  { name: "Trà Vinh", latitude: 9.9346, longitude: 106.2547 },
  { name: "Sóc Trăng", latitude: 9.6025, longitude: 105.9739 },
  { name: "Bến Tre", latitude: 10.2417, longitude: 106.3758 },
  { name: "Tiền Giang", latitude: 10.36, longitude: 106.3625 },
  { name: "Vĩnh Long", latitude: 10.253, longitude: 105.972 },
  { name: "Long An", latitude: 10.5306, longitude: 106.41 },
  { name: "Tây Ninh", latitude: 11.31, longitude: 106.098 },
  { name: "Bình Phước", latitude: 11.4521, longitude: 106.8428 },
  { name: "Bình Thuận", latitude: 10.9334, longitude: 108.1 },
  { name: "Bà Rịa - Vũng Tàu", latitude: 10.5417, longitude: 107.175 },
  { name: "Đắk Lắk", latitude: 12.6667, longitude: 108.2167 },
  { name: "Đắk Nông", latitude: 11.8175, longitude: 107.5333 },
  { name: "Gia Lai", latitude: 13.9833, longitude: 108.0 },
  { name: "Kon Tum", latitude: 14.35, longitude: 108.0 },
  { name: "Lào Cai", latitude: 22.4854, longitude: 103.9708 },
  { name: "Yên Bái", latitude: 21.7167, longitude: 104.85 },
  { name: "Thái Nguyên", latitude: 21.5942, longitude: 105.8482 },
  { name: "Tuyên Quang", latitude: 21.8233, longitude: 105.2142 },
  { name: "Phú Thọ", latitude: 21.3189, longitude: 105.4 },
  { name: "Vĩnh Phúc", latitude: 21.3089, longitude: 105.6048 },
  { name: "Bắc Giang", latitude: 21.2889, longitude: 106.1948 },
  { name: "Bắc Ninh", latitude: 21.1858, longitude: 105.975 },
  { name: "Hải Dương", latitude: 20.9373, longitude: 106.3146 },
  { name: "Hưng Yên", latitude: 20.6464, longitude: 106.0514 },
  { name: "Thái Bình", latitude: 20.4484, longitude: 106.2703 },
  { name: "Hà Nam", latitude: 20.54, longitude: 105.9083 },
  { name: "Nam Định", latitude: 20.42, longitude: 106.1683 },
  { name: "Ninh Bình", latitude: 20.2506, longitude: 105.9746 },
  { name: "Quảng Ninh", latitude: 20.9533, longitude: 107.0823 },
  { name: "Hòa Bình", latitude: 20.8167, longitude: 105.3375 },
  { name: "Sơn La", latitude: 21.3269, longitude: 103.9138 },
  { name: "Điện Biên", latitude: 21.3864, longitude: 103.0167 },
  { name: "Lai Châu", latitude: 22.3961, longitude: 103.4578 },
  { name: "Cao Bằng", latitude: 22.6656, longitude: 106.2578 },
  { name: "Bắc Kạn", latitude: 22.0769, longitude: 105.8125 },
  { name: "Lạng Sơn", latitude: 21.8533, longitude: 106.7614 },
  { name: "Hà Giang", latitude: 22.8026, longitude: 104.9785 },
  { name: "Ninh Thuận", latitude: 11.5673, longitude: 108.9913 },
  { name: "Hà Tĩnh", latitude: 18.3568, longitude: 105.9053 },
  { name: "Quảng Bình", latitude: 17.4806, longitude: 106.6046 },
  { name: "Quảng Trị", latitude: 17.2206, longitude: 106.6008 },
  { name: "Đồng Tháp", latitude: 10.46, longitude: 105.63 },
] as const;

const aliases = new Map<string, string>([
  ["saigon", "ho chi minh"],
  ["sai gon", "ho chi minh"],
  ["nha trang", "khanh hoa"],
  ["cam ranh", "khanh hoa"],
  ["hue", "thua thien hue"],
  ["ha long", "quang ninh"],
  ["vung tau", "ba ria vung tau"],
  ["thu dau mot", "binh duong"],
  ["bien hoa", "dong nai"],
  ["da lat", "lam dong"],
  ["buon ma thuot", "dak lak"],
  ["pleiku", "gia lai"],
  ["quy nhon", "binh dinh"],
  ["tuy hoa", "phu yen"],
  ["phan thiet", "binh thuan"],
  ["rach gia", "kien giang"],
  ["long xuyen", "an giang"],
  ["my tho", "tien giang"],
]);

function normalizeName(input: string): string {
  return input
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[đĐ]/g, "d")
    .toLowerCase()
    .replace(/^(tp|tinh|thanh pho|thanhpho)\s*/u, "")
    .replace(/[^a-z ]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

const normalizedProvinces = provinces.map((province) => ({
  province,
  key: normalizeName(province.name),
}));

export function lookupVietnamProvince(
  input: string,
):
  | (VietnamProvince & { ianaTimeZone: "Asia/Ho_Chi_Minh"; countryCode: "VN" })
  | null {
  const key = normalizeName(input);
  if (key.length < 3) {
    return null;
  }
  const aliasKey = aliases.get(key);
  const target = aliasKey ?? key;

  for (const { province, key: name } of normalizedProvinces) {
    if (name === target || name.includes(target) || target.includes(name)) {
      return Object.freeze({
        ...province,
        ianaTimeZone: "Asia/Ho_Chi_Minh",
        countryCode: "VN",
      });
    }
  }

  return null;
}
